var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "lead-coordinator cursor-pointer" }, [
      _c(
        "span",
        { staticClass: "info-bubbles" },
        _vm._l(_vm.deliverable.users, function(user, index) {
          return _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.html",
                  modifiers: { hover: true, html: true }
                }
              ],
              staticClass: "initials badge badge-primary",
              class: _vm.getColorClass(),
              attrs: { title: user.name }
            },
            [
              _c("span", { staticClass: "exclude-outside-click" }, [
                _vm._v(_vm._s(_vm._f("textInitials")(user.name)))
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }